import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=2b0e8d2e&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=2b0e8d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e8d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0e8d2e')) {
      api.createRecord('2b0e8d2e', component.options)
    } else {
      api.reload('2b0e8d2e', component.options)
    }
    module.hot.accept("./SearchInput.vue?vue&type=template&id=2b0e8d2e&scoped=true&", function () {
      api.rerender('2b0e8d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreSearch/components/SearchInput.vue"
export default component.exports